<template>
  <div class="center-div">
    <a-row class="justify-center">
      <a-col :span="7">
        <div class="mt-4" style="text-align:center">
          <h4 class="text-bold">Login to your Account</h4>
          <span class="text-opacity">Leverage the power of convenience</span>
        </div>
        <div v-show="errorMessages.length > 0 ">
          <error-alert v-for="(msg,index) in errorMessages" :key="index" :message="msg"></error-alert>
        </div>
        <a-card class="mt-4">
          <a-form :form="form" @submit="loginUser">
            <a-form-item class="form-input">
              <h4 class="text-opacity">Your Username</h4>
              <a-input
                v-decorator="['email', { rules: [{ required: true, message: 'Please input your username!' }] }]"
                class="custom-input"
                type="text"
                placeholder="Please Enter your Username"
              />
            </a-form-item>
            <a-form-item class="form-input">
              <h4 class="text-opacity">Your Password</h4>
              <a-input
                v-decorator="['password', { rules: [{ required: true, message: 'Please input your password!' }] }]"
                class="custom-input"
                :type="display"
                placeholder="Please Enter your Password"
              />
              <span class="show-toggle">
                <a-icon @click="toggleShow" type="eye" v-show="show"/>
                <a-icon @click="toggleShow" type="eye-invisible" v-show="hide"/>
              </span>
            </a-form-item>
            <a-form-item>
              <router-link :to="{name: 'forgot-password'}">
                <b class="text-color text-purple" style="float:right">Forgot Password?</b>
              </router-link>
            </a-form-item>
            <a-form-item class="mt-2">
              <button type="submit" class="btn btn-primary">Login</button>
            </a-form-item>
            <span>
              Not yet a user,
              <router-link :to="{name: 'register'}">
                <b class="text-purple">Sign up</b>
              </router-link>to create your Account
            </span>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<style scoped>
.btn-primary {
  width: 100%;
  height: 40px;
  padding-top: 0px !important;
}
</style>
<script>
import "@/assets/css/auth.scss";
import ErrorAlert from "@/components/Alerts/Error";
import { setTimeout } from "timers";
export default {
  components: { ErrorAlert },
  data() {
    return {
      hide: false,
      show: true,
      display: "password",
      form: this.$form.createForm(this, { name: "coordinated" }),
      api: this.$baseApi.replace("api/", ""),
      errorMessages: []
    };
  },
  methods: {
    loginUser(e) {
      e.preventDefault();
      this.errorMessages = [];
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const hide = this.$message.loading(
            "Logging you in, Please hold on a minute"
          );
          let redirect = this.$auth.redirect();
          this.$auth.login({
            data: { username: values.email, password: values.password },
            rememberMe: true,
            redirect: {
              name: redirect ? redirect.from.name : "home",
              params:
                redirect && redirect.from && redirect.from.params
                  ? redirect.from.params
                  : "",
              query:
                redirect && redirect.from && redirect.from.query
                  ? redirect.from.query
                  : ""
            },
            success: s => {
              let token = s.data.access_token;
              if (
                document.referrer &&
                document.referrer.indexOf(
                  location.protocol + "//" + location.host
                ) !== 0
              ) {
                window.location.href = document.referrer + "?token=" + token;
              }
              setTimeout(hide, 20);
            },
            error: err => {
              setTimeout(hide, 20);
              if (err && err.response) {
                this.errorMessages.push([
                  "Sorry, " + err.response.data.message
                ]);
              }
            }
          });
        }
      });
    },
    toggleShow() {
      if (this.hide === false) {
        this.hide = true;
        this.display = "password";
      } else {
        this.hide = false;
        this.display = "text";
      }
      if (this.show == true) {
        this.show = false;
        this.display = "text";
      } else {
        this.show = true;
        this.display = "password";
      }
    }
  }
};
</script>

